
webpack.register(
    'components/image-universal/image-universal',
    function() {
        return require('components/image-universal/image-universal');
    },
    false
);
webpack.register(
    'components/history-experience/scoring-and-stats/leaderboard/drawer/scorecard/scorecard',
    function() {
        return require('components/history-experience/scoring-and-stats/leaderboard/drawer/scorecard/scorecard');
    },
    false
);
webpack.register(
    'components/history-experience/scoring-and-stats/leaderboard/drawer/round-switcher/round-switcher',
    function() {
        return require('components/history-experience/scoring-and-stats/leaderboard/drawer/round-switcher/round-switcher');
    },
    false
);
webpack.register(
    'components/fetching-loader/fetching-loader',
    function() {
        return require('components/fetching-loader/fetching-loader');
    },
    false
);
webpack.register(
    'components/svg-image/svg-image',
    function() {
        return require('components/svg-image/svg-image');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/image-universal/image-universal'/>\r\n<can-import from='components/history-experience/scoring-and-stats/leaderboard/drawer/scorecard/scorecard'/>\r\n<can-import from='components/history-experience/scoring-and-stats/leaderboard/drawer/round-switcher/round-switcher'/>\r\n<can-import from='components/fetching-loader/fetching-loader' />\r\n<can-import from='components/svg-image/svg-image' />\r\n\r\n<div class=\"s-leaderboard-drawer-history\">\r\n    {{#isDataAvailable}}\r\n        <div class=\"s-drawer-head\">\r\n            <round-switcher {rounds}=\"data.rounds\" {(round)}=\"round\"/></round-switcher>\r\n            <button class=\"s-drawer-head__close js-drawer-close\" aria-label=\"close\">CLOSE</button>\r\n        </div>\r\n\r\n        <div class=\"s-drawer-content clearfix\">\r\n            <div class=\"s-drawer-cell dynamic-cell cell-scorecard is-display-desktop is-display-tablet is-display-mobile\" data-type=\"scorecard\">\r\n                <div class=\"container-scorecard\">\r\n                    <leaderboard-scorecard {round}=\"round\" {player}=\"data\"></leaderboard-scorecard>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    {{else}}\r\n        <div class=\"s-drawer-head\">\r\n            <button class=\"s-drawer-head__close js-drawer-close\" aria-label=\"close\">CLOSE</button>\r\n        </div>\r\n        <div class=\"s-drawer-content s-drawer-content--error clearfix\">\r\n            <div class=\"s-drawer-svg\">\r\n                <svg-image image=\"sprites.svg#icon-notebook\"></svg-image>\r\n            </div>\r\n            <div class=\"s-drawer-content__text\">\r\n                HISTORICAL SCORECARD DATA IS NOT AVAILABLE FOR THIS PLAYER\r\n            </div>\r\n        </div>\r\n    {{/isDataAvailable}}\r\n</div>");